import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  toastStruct = {
    title: '',
    message: '',
    type: '',
    icon: ''
  };

    //destination code
    customerUser = new BehaviorSubject<any>({});

  constructor(private _snackBar: MatSnackBar, private route: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  openToastMessage(message: string) {
    this._snackBar.open(message, 'Okay', {
    });
  }

  // statementDownload(message: string) {
  //   let data = this.toastStruct;
  //   data.message = message
  //   data.title = 'Exported Successfully'
  //   data.type = 'success'

  //   let s = this._snackBar.openFromComponent(ToastComponent, {
  //     data: data,
  //     duration: 4 * 1000,
  //     horizontalPosition: 'right',
  //     verticalPosition: 'top',
  //     panelClass: ['toast', 'box-shadow'],
  //   });
  // }

  renameFileName(fileName) {
    let strList = fileName.split('.')
    let ex = strList[strList.length - 1];
    fileName = fileName.replace(/[^a-zA-Z0-9]/g, '_');
    let result = ''
    if (!!localStorage.getItem('user')) {
      result = !!localStorage.getItem('user') ? (JSON.parse(localStorage.getItem('user') || '')?.id + "_") : '_'
    }
    result = fileName + '_' + result + moment().utc().format('YYYY-MM-DD_HH:mm:ss') + '.' + ex;
    result = result.trim();
    result = result.toString().replace('#', '');
    return result
  }

  downloadPdf(name, data) {
    const linkSource = `data:application/pdf;base64,${data}`;
    const downloadLink = document.createElement('a');
    const fileName = name + "_" + (new Date().getTime().toString()) + '.pdf';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  validation(obj, requiredFields) {
    const validationStatus = {};
    requiredFields.forEach(field => {
      validationStatus[field] = !obj[field] || (Array.isArray(obj[field]) && obj[field].length === 0) || (Object.keys(obj[field]).length === 0);
    });
    return validationStatus;
  }


  redirectToDasboard(message) {
    this._snackBar.open(message, 'Okay', {
      duration: 3000
    });
    this.route.navigate(['main/dashboard']);
  }

  autoCompletePannelWidth() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth <= 600) {
        return (window.innerWidth - 50) + 'px';
      } else {
        return '400px';
      }
    }
    return '400px';
  }

  afterSelectLocation(inputType, getObj) {
    if (!!getObj.move_type && !!getObj[inputType] && !!getObj[inputType].id) {
      let type = !!getObj[inputType] && !!getObj[inputType].location_type ? (!!getObj[inputType].location_type && (getObj[inputType].location_type).toLowerCase() == "port" ? 'port' : (!!getObj[inputType].location_type && (getObj[inputType].location_type).toLowerCase() == "zipcode" ? 'door' : 'cy')) : 'port';
      let list = getObj.move_type.split("_");
      if (inputType == "from") {
        list[0] = type;
      } else {
        list[1] = type;
      }
      getObj.move_type = list.join("_");
    }
    return getObj.move_type;
  }


  parseBookingStoreInfo(rateInfo, linerChargeInfo, originChargeObj, destinationChargeObj, additionalServiceMapObj, getObj,breakdownArray?) {
    let obj = <any>{};
    let linerCharge = <any>[];
    rateInfo["no_of_container"] = !!getObj && !!getObj.no_of_container ? getObj.no_of_container : 1;
    if ((!!rateInfo.liner.id || !!rateInfo.liner_id) && !!linerChargeInfo[rateInfo.liner_id ? rateInfo.liner_id : rateInfo.liner.id]) {
      linerCharge = JSON.parse(JSON.stringify(linerChargeInfo[rateInfo.liner_id ? rateInfo.liner_id : rateInfo.liner.id]));
    }
    if (rateInfo.rate_type == "spot" && !!rateInfo.vessel_details && !!rateInfo.vessel_details.length) {
      obj["vessel_schedule"] = rateInfo.vessel_details[0];
    }

    if (!!originChargeObj && !!originChargeObj[rateInfo.liner_id]) {
      obj['origin_charge'] = originChargeObj[rateInfo.liner_id];
    }
    if (!!destinationChargeObj && !!destinationChargeObj[rateInfo.liner_id]) {
      obj['destination_charge'] = destinationChargeObj[rateInfo.liner_id];
    }
    if (!!additionalServiceMapObj && !!additionalServiceMapObj?.is_applied) {
      obj['additional_service'] = additionalServiceMapObj;
    }
    if (!!rateInfo.weight_applied && !!rateInfo.weight_column && !!rateInfo.weight_column.length && !!rateInfo.weight) {
      rateInfo?.weight_column.forEach(i => {
        if (!!i["applied"] && !!rateInfo?.weight[i["column_name"]]) {
          rateInfo["_" + rateInfo?.weight[i["column_name"]]] = rateInfo?.weight[i["column_name"]];
          linerCharge.push({
            "charge_head_expansion": "Excess Weight Fee", "column_name": "_" + i["column_name"], "currency": {
              "id": 3,
              "value": "USD"
            }
          })
        }
      })
    }
    if (!!rateInfo.other_charges && !!rateInfo.other_charges_header) {
      linerCharge.push({
        "charge_head_expansion": rateInfo.other_charges_header, "column_name": "other_charges", "currency": {
          "id": 3,
          "value": "USD"
        }
      })
    }
    if (!!breakdownArray && !!breakdownArray[rateInfo.liner_id]) {
      obj['trucking_charge'] = breakdownArray[rateInfo.liner_id];
    }
    obj["price_info"] = rateInfo;
    obj["liner_charge"] = linerCharge;

    return obj;
  }
  payableChargeCalculator(rateInfo) {
    let payableObj: { [key: string]: any } = {}; 
    const chargeTotal = rateInfo["_total"] as { [key: string]: any }; // Assuming _total is an object

    Object.values(chargeTotal).forEach((v: any) => {
      if (!!v) {
        const obj = v as { [key: string]: any };

        if (obj["currency"] && obj["currency"]["id"] && obj["value"] && obj["value"] !== 0) {
          const currencyId = String(obj["currency"]["id"]);

          if (payableObj[currencyId]) {
            payableObj[currencyId]["value"] += obj["value"];
          } else {
            payableObj[currencyId] = {
              currency: obj["currency"],
              value: obj["value"],
            };
          }
        }
      }

    });
    let list: any[] = Object.values(payableObj); // Extracts values from the object
    rateInfo["total_payable"] = list;
    return rateInfo
  }

  additonalServiceTotalAdder(rateList, spotRateList, additionalServiceMapObj, singleRateInfo: any = null) {
    if (!!singleRateInfo) {
      if (!!additionalServiceMapObj && !!additionalServiceMapObj["is_applied"] && !!additionalServiceMapObj["total"]) {
        additionalServiceMapObj["group_list"].forEach(group => {
          if (!!additionalServiceMapObj["total"][group]) {
            singleRateInfo["_total"]["total_" + group + "_additional_service"] = additionalServiceMapObj["total"][group];
            singleRateInfo = this.payableChargeCalculator(singleRateInfo);
          } else {
            delete singleRateInfo["_total"]["total_" + group + "_additional_service"];
            singleRateInfo = this.payableChargeCalculator(singleRateInfo);
          }
        });
      } else {
        singleRateInfo = this.removeAddtionalService(rateList, spotRateList, additionalServiceMapObj, singleRateInfo);
      }
      return singleRateInfo;
    } else {
      rateList.forEach(i => {
        if (!!additionalServiceMapObj && !!additionalServiceMapObj["is_applied"] && !!additionalServiceMapObj["total"]) {
          additionalServiceMapObj["group_list"].forEach(group => {
            if (!!additionalServiceMapObj["total"][group]) {
              i["_total"]["total_" + group + "_additional_service"] = additionalServiceMapObj["total"][group];
              i = this.payableChargeCalculator(i);
            } else {
              delete i["_total"]["total_" + group + "_additional_service"];
              i = this.payableChargeCalculator(i);
            }
          });
        } else {
          this.removeAddtionalService(rateList, spotRateList, additionalServiceMapObj);
        }
      });
      if (!!spotRateList && !!spotRateList.length) {
        spotRateList.forEach(i => {
          // i["_total"] = {};
          if (!!additionalServiceMapObj && !!additionalServiceMapObj["is_applied"] && !!additionalServiceMapObj["total"]) {
            additionalServiceMapObj["group_list"].forEach(group => {
              if (!!additionalServiceMapObj["total"][group]) {
                i["_total"]["total_" + group + "_additional_service"] = additionalServiceMapObj["total"][group];
                i = this.payableChargeCalculator(i);
              } else {
                delete i["_total"]["total_" + group + "_additional_service"];
                i = this.payableChargeCalculator(i);
              }
            });
          } else {
            this.removeAddtionalService(rateList, spotRateList, additionalServiceMapObj);
          }
        });
      }
      return { rateList, spotRateList };
    }



  }

  removeAddtionalService(rateList, spotRateList, additionalServiceMapObj, singleRateInfo: any = null) {
    additionalServiceMapObj['group_list'].forEach(group => {
      if (!!additionalServiceMapObj['value_list'][group]) {
        additionalServiceMapObj['value_list'][group].forEach(i => {
          if (i['charge_list']) {
            i['charge_list'].forEach(j => {
              j.checked = false;
            })
          } else {
            i.checked = false;
          }
        })
      }

    });
    additionalServiceMapObj["is_applied"] = false;
    additionalServiceMapObj["total"] = null;
    additionalServiceMapObj["_count"] = 0;
    additionalServiceMapObj["selected_obj"] = null;
    if (!!singleRateInfo) {
      if (!!additionalServiceMapObj && !additionalServiceMapObj["is_applied"]) {
        additionalServiceMapObj["group_list"].forEach(group => {
          delete singleRateInfo["_total"]["total_" + group + "_additional_service"];
          singleRateInfo = this.payableChargeCalculator(singleRateInfo);
        });
      }
      return singleRateInfo;
    } else {

      rateList.forEach(i => {
        if (!!additionalServiceMapObj && !additionalServiceMapObj["is_applied"]) {
          additionalServiceMapObj["group_list"].forEach(group => {
            delete i["_total"]["total_" + group + "_additional_service"];
            i = this.payableChargeCalculator(i);
          });
        }
      });
      if (!!spotRateList && !!spotRateList.length) {
        spotRateList.forEach(i => {
          // i["_total"] = {};
          if (!!additionalServiceMapObj && !additionalServiceMapObj["is_applied"]) {
            additionalServiceMapObj["group_list"].forEach(group => {
              delete i["_total"]["total_" + group + "_additional_service"];
              i = this.payableChargeCalculator(i);
            });
          }
        });
      }
      return { rateList, spotRateList };
    }

  }

  selectAdditionalService(addtionalServiceObjLocal) {
    let isApplied = false;
    let selectedListObj = {};
    let total = {};
    let count = 0;
    addtionalServiceObjLocal['group_list'].forEach(group => {
      if (!!addtionalServiceObjLocal['value_list'][group]) {
        addtionalServiceObjLocal['value_list'][group].forEach(i => {
          if (i['charge_list']) {
            i['charge_list'].forEach(j => {
              if (j.checked) {
                isApplied = true;
                if (!selectedListObj[group]) {
                  selectedListObj[group] = [];
                }
                if (!total[group]) {
                  total[group] = { value: 0, currency: i.currency };
                }
                total[group]["value"] = total[group]["value"] + j["value"];
                count += 1;
                selectedListObj[group].push(j);
              }
            })
          } else {
            if (i.checked) {
              isApplied = true;
              if (!selectedListObj[group]) {
                selectedListObj[group] = [];
              }
              if (!total[group]) {
                total[group] = { value: 0, currency: i.currency };
              }
              total[group]["value"] = total[group]["value"] + i["value"];
              count += 1;
              selectedListObj[group].push(i);
            }
          }
        })
      }

    });
    addtionalServiceObjLocal["is_applied"] = isApplied;
    addtionalServiceObjLocal["total"] = total;
    addtionalServiceObjLocal["_count"] = count;
    addtionalServiceObjLocal["selected_obj"] = selectedListObj;
    return addtionalServiceObjLocal;
  }



  mysqlDateFormat(date: string) {
    return moment(date).format('YYYY-MM-DD');
  }

  dateFormat(date, format) {
    return moment(date).format(format);
  }

  
}
